import CreateReducer from '../utils/createReducer'
import CreateActions from '../utils/createActions'

import {
  handlers,
} from '../utils/api'

import networkWrapper from '../utils/networkWrapper'
import projectSelectors from '../selectors/project'

const prefix = 'project'
const wrapper = networkWrapper.factory(prefix)

const initialState = {
  bookingForms: [],
  configs: [],
}

const reducers = {
  setBookingForms: (state, action) => {
    state.bookingForms = action.payload
  },
  setConfigs: (state, action) => {
    state.configs = action.payload
  },
}

const sideEffects = {

  loadAdminBookingforms: () => wrapper('loadAdminBookingforms', async (dispatch, getState) => {
    const project = projectSelectors.currentProjectId(getState())
    const data = await handlers.get(`/admin/projects/${project}/bookingforms`)
    dispatch(actions.setBookingForms(data))
  }),

  loadAdminBookingformConfigs: (id) => wrapper('loadAdminBookingformConfigs', async (dispatch, getState) => {
    const project = projectSelectors.currentProjectId(getState())
    const data = await handlers.get(`/admin/projects/${project}/bookingforms/${id}/configs`)
    dispatch(actions.setConfigs(data))
  }),

}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export { actions, reducer }
export default actions